import queryString from "querystring"
import types       from "./types"

const { "fiscal-year": year } = queryString.parse(
    window.location.search.replace("?", ""),
)

const initialState = {
    selectedFiscalYear: year,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_FISCALYEAR:
            return { ...state, selectedFiscalYear: action.payload }
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/infraMonitor/fiscalyear/reducers.js